import React, { useEffect, useState, createContext } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Swal from "sweetalert2";
import MDBox from "components/MDBox";
import { Card, CardHeader, CircularProgress, Box } from "@mui/material";

import { useLocation } from "react-router-dom";
import SearchEntries from "./SearchEntries";
import EntriesTable from "./EntriesTable";
import AccountingApi from "../../../Classes/API/AccountingApi";
import SearchAccountingEntriesReq from "../../../Classes/Models/Requests/Accounting/SearchAccountingEntriesReq";
import Loader from "Loader";
import CreateAccountingEntryReq from "../../../Classes/Models/Requests/Accounting/CreateAccountingEntryReq";
const index = () => {
  const { state } = useLocation();
  // let req = SearchStringOrIntReq5

  let tempReq = new CreateAccountingEntryReq();

  const [IsLoaded, setIsLoaded] = useState(false);
  const [Entries, setEntries] = useState({});
  const [SearchRequest, setSearchRequest] = useState(new CreateAccountingEntryReq());

  useEffect(async () => {
    await GetEntries(SearchRequest);
  }, [SearchRequest]);
  const GetEntries = async (req) => {
    var res = await AccountingApi.SearchAccountingEntries(req);
    if (res.status == "Success") {
      setEntries(res.data);
      setIsLoaded(true);
      Swal.close();
      console.log(res.data);
    } else {
      setIsLoaded(false);
    }
  };

  // useEffect(() => {
  //   if (!IsLoaded) {
  //     GetEntries(tempReq);
  //   }
  // }, [IsLoaded]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SearchEntries setSearchRequest={setSearchRequest} GetEntries={GetEntries} />

      {!IsLoaded ? (
        <Loader />
      ) : (
        <EntriesTable
          GetEntries={GetEntries}
          SearchRequest={SearchRequest}
          setSearchRequest={setSearchRequest}
          Entries={Entries}
        />
      )}
    </DashboardLayout>
  );
};
export default index;
